module.exports = __webpack_public_path__ + "img/Talk To CS Message.2724a93c.png";